import React, { useState, useEffect, useRef } from "react";
import {Image} from 'antd'
import {Shimmer} from 'components/Shimmer';


const ImageBox = ({ imgUrl, fallbackUrl, alt="", imgIndex=0, onClick, shimmerStyles={} }) => {
  const [loading, setLoading] = useState(true);
  const [imgSrc, setImageSrc] = useState(imgUrl)
  const imageRef = useRef();

  const handleOnError = function handleOnError() {
    setImageSrc(fallbackUrl)
  };

  const handleOnLoad = function handleOnLoad() {
    setLoading(false)
  };

  return (
    <>
    <div style={!loading?{}:{display:'none'}} onClick={onClick} disabled={!onClick}>
      <Image
        ref={imageRef}
        src={imgUrl}
        alt={alt}
        onLoad={handleOnLoad}
        onError={handleOnError}
        width={'100%'}
        height={'100%'}
        key={imgIndex}
        fallback={fallbackUrl}
        preview={false}
      />
      </div>
      <div style={loading?{}:{display:'none'}}>
        <Shimmer style={shimmerStyles}/>
      </div>
    </>
  );
};

export default ImageBox;
